import { useSearchParams } from "react-router-dom";
import { CloudOff, ImageIcon, MonitorPlay, Palette } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader, Loader } from "@/components/common";
import { SAVE_FAIL, useLook } from "@/context/LookContext";
import ThemeTab from "@/components/look/ThemeTab";
import WallpaperTab from "@/components/look/WallpaperTab";
import ScreensaverTab from "@/components/look/ScreensaverTab";

const TABS = [
  { id: "theme", label: "Theme", Icon: Palette },
  { id: "wallpaper", label: "Wallpaper", Icon: ImageIcon },
  { id: "screensaver", label: "Screensaver", Icon: MonitorPlay },
];

export default function MyLook() {
  const { look, saveError } = useLook();
  const [params, setParams] = useSearchParams();
  const tab = TABS.some((t) => t.id === params.get("tab")) ? params.get("tab") : "theme";
  if (!look) return <Loader />;

  return (
    <div data-testid="my-look-page">
      <PageHeader eyebrow="Family · just for you" title="My Look" rgb="var(--glow-family)" testid="my-look-title" />
      <p className="-mt-5 mb-8 max-w-xl text-sm text-q-muted q-rise q-onwall">Your theme, wallpaper and screensaver follow you to every device. Nobody else's screen changes.</p>
      {saveError && (
        <div className="mb-6 flex items-center gap-2 rounded-lg border px-3.5 py-2.5 text-sm font-semibold" data-testid="look-save-error"
          style={{ borderColor: "rgba(var(--glow-media),0.4)", background: "rgba(var(--glow-media),0.1)", color: "rgb(var(--q-danger-text))" }}>
          <CloudOff className="h-4 w-4 flex-shrink-0" /> {SAVE_FAIL}
        </div>
      )}
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })}>
        <TabsList className="mb-8 h-auto w-full justify-start gap-1 overflow-x-auto rounded-xl border border-q-border bg-q-surface p-1 sm:w-auto" data-testid="my-look-tabs">
          {TABS.map(({ id, label, Icon }) => (
            <TabsTrigger key={id} value={id} data-testid={`look-tab-${id}`}
              className="flex-1 gap-2 rounded-lg px-4 py-2 text-sm font-semibold text-q-muted data-[state=active]:bg-q-raised data-[state=active]:text-q-text data-[state=active]:shadow-none sm:flex-none">
              <Icon className="h-4 w-4" /> {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="theme"><ThemeTab /></TabsContent>
        <TabsContent value="wallpaper"><WallpaperTab /></TabsContent>
        <TabsContent value="screensaver"><ScreensaverTab /></TabsContent>
      </Tabs>
    </div>
  );
}
